import { Reducer } from "redux";
import { ActionTypes } from "../constants/actions";

export interface ICommonState {
  isLoaderVisible: boolean;
  isSuccess: boolean;
  isToasterVisible: boolean;
  toasterMessage: string;
  isLoggedIn: boolean;
  allowFetchGridData: boolean;
  confirmDialog: {
    open: boolean;
    title: string;
    content: string;
    key: string; // This key will have a unique value to execute function on click of OK
  };
  pageTitle: string;
}

const initialState: ICommonState = {
  isLoaderVisible: false,
  isSuccess: false,
  isToasterVisible: false,
  toasterMessage: "",
  isLoggedIn: false,
  allowFetchGridData: true,
  confirmDialog: {
    open: false,
    title: "",
    content: "",
    key: "",
  },
  pageTitle: "",
};

export const commonReducer: Reducer<ICommonState> = (
  state: ICommonState = initialState,
  action: any
) => {
  switch (action.type) {
    case ActionTypes.COMMON.SET_LOADER_VISIBILITY:
      return {
        ...state,
        isLoaderVisible: action.payload,
      };
    case ActionTypes.COMMON.SET_TOASTER_VISIBILITY:
      return {
        ...state,
        isSuccess: action.payload.success,
        isToasterVisible: action.payload.visible,
        toasterMessage: action.payload.data,
      };
    case ActionTypes.COMMON.IS_LOGGED_IN:
      return {
        ...state,
        isLoggedIn: action.payload,
      };

    case ActionTypes.COMMON.ALLOW_FETCH_GRID_DATA:
      return {
        ...state,
        allowFetchGridData: action.payload,
      };

    case ActionTypes.COMMON.SET_CONFRIM_DAILOG_VISIBILITY:
      return {
        ...state,
        confirmDialog: action.payload,
      };
    case ActionTypes.COMMON.SET_PAGE_TITLE:
      return {
        ...state,
        pageTitle: action.payload.data,
      };
    default:
      return state;
  }
};
